export default from './oneLineTrim';
